'use strict';

/**
 * Displays job cards with "Load More" functionality.
 *
 * - Shows a limited number of cards initially.
 * - Loads more cards when the button is clicked.
 * - Hides the button when all cards are visible.
 */
function jobCards() {
    $('.ckc-job-listing-layout').each(function () {
        var $layout = $(this);
        var initialCount = parseInt($layout.data('initial-count'), 10) || 0;
        var loadCount = parseInt($layout.data('load-count'), 10) || 0;
        var $region = $layout.find('.experience-main');
        var $cards = $region.children('.experience-component');
        var $loadMoreBtn = $layout.find('.load-more-job-btn');

        // If no initialCount or <= 0, show all cards and hide button
        if (!initialCount || initialCount <= 0) {
            $cards.show();
            $loadMoreBtn.addClass('d-none').hide();
            return;
        }

        // Initially hide all cards and show only initialCount
        $cards.hide().slice(0, initialCount).show();

        // Show/hide the Load More button
        if ($cards.length > initialCount) {
            $loadMoreBtn.removeClass('d-none').show();
        } else {
            $loadMoreBtn.addClass('d-none').hide();
        }

        // On click, load more cards
        $loadMoreBtn.on('click', function () {
            var visibleCount = $region.children('.experience-component:visible').length;

            // If loadCount not configured or <= 0 → show all remaining cards
            if (!loadCount || loadCount <= 0) {
                $cards.slice(visibleCount).fadeIn();
            } else {
                $cards.slice(visibleCount, visibleCount + loadCount).fadeIn();
            }

            // Hide button if all cards are visible
            if ($cards.filter(':visible').length >= $cards.length) {
                $loadMoreBtn.addClass('d-none').hide();
            }
        });
    });
}

module.exports = {
    jobCards
};
